import { createApp } from 'vue';
import App from './App.vue';
import { ConfigProvider } from 'ant-design-vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import './styles/tokens.css';
import './styles/vaporwave-components.css';
import './styles/page-layout.css';
import './styles/popup-overrides.css';
import './styles/admin-app-buttons.css';
import './styles/ice-fire-pages.css';
import './style.css';
import './styles/admin-shell.css';

import { createPinia } from 'pinia';
import { router } from './router';
import { setupRouterWithAuth } from './router/setupRouterWithAuth';
import adminLocale, { renderAntdEmpty } from './locale/antd';

// 下拉選單 Teleport 至 body，需在啟動時設定全域 locale / renderEmpty
ConfigProvider.config({
    locale: adminLocale,
    renderEmpty: renderAntdEmpty
});

async function boot() {
    const app = createApp(App);
    const pinia = createPinia();

    app.use(Antd);
    app.use(pinia);

    // 等權限與私有路由處理完再加載註冊 router
    await setupRouterWithAuth();
    app.use(router);
    app.mount('#app');
}

boot();
